import { StatoPlesso } from "./enum/StatoPlesso";

export class Plesso {
    id?: string;
    idIstituto?: string;
    nome?: string;
    stato?: StatoPlesso
}